import ListLoadingNotification from "lib/ui/list-loading-notification";
import useInfiniteScroll from "lib/use-infinite-scroll";
import PropTypes from "prop-types";
import React, { Fragment } from "react";

const InfiniteList = ({ getData, renderListItem, onSelect }) => {
  const {
    items,
    setScroller: setInfiniteScroller,
    handleScroll: handleInfiniteScroll,
    isLoading
  } = useInfiniteScroll(getData);

  const setScroller = element => {
    setInfiniteScroller(element);
  };

  const handleScroll = () => {
    handleInfiniteScroll();
  };

  const renderListItems = () => {
    return items.map(item => (
      <Fragment key={item.id}>
        <div
          className="event flex-none p-2 my-1 border border-gray-300 rounded hover:bg-blue-200 cursor-pointer"
          onClick={() => onSelect(item)}
        >
          {renderListItem(item)}
        </div>
      </Fragment>
    ));
  };

  return (
    <div
      className="max-h-full w-1/4 bg-white overflow-y-scroll rounded"
      ref={element => setScroller(element)}
      onScroll={handleScroll}
    >
      <div>{renderListItems()}</div>
      {isLoading && <ListLoadingNotification />}
    </div>
  );
};

InfiniteList.propTypes = {
  getData: PropTypes.func.isRequired,
  renderListItem: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default InfiniteList;
